// extracted by mini-css-extract-plugin
module.exports = {"lostandfound":"LostandFound_lostandfound__lQH7i","content":"LostandFound_content__8vsia"};